import cx from 'classnames';
import {Button} from '../atoms/Button';
import {link} from '../sass/base/_exports.sass';
import {DiamondIcon} from '../svg/DiamondIcon';
import {EditLineIcon} from '../svg/EditLineIcon';
import {TrashIcon} from '../svg/TrashIcon';

export const EditRemoveButton = ({
  editLabel = 'Edit',
  editButtonAriaLabel,
  fullWidth = false,
  removeLabel = 'Remove',
  onEditClick,
  onRemoveClick,
  inverted,
  hideEdit = false,
  hideRemove = false,
  className = '',
  dataQaIdSuffix,
  showDiamond,
}) => (
  <div
    className={cx(className, {
      'add-remove-button__container__full-width': fullWidth,
      'add-remove-button__container__inverted': inverted,
    })}
  >
    <div
      className={cx({
        'add-remove-button': !hideEdit && !hideRemove,
        'add-remove-button__single_button': hideEdit || hideRemove,
      })}
    >
      {!hideEdit && (
        <Button
          ariaLabel={editButtonAriaLabel}
          data-qa-id={`edit-${dataQaIdSuffix}`}
          variant="link"
          className="add-remove-button__button"
          onClick={onEditClick}
        >
          <EditLineIcon ratio={0.5} color={link} />
          {editLabel}
        </Button>
      )}
      {!hideEdit && !hideRemove && <span className="spacer">|</span>}
      {!hideRemove && (
        <Button
          data-qa-id={`remove-${dataQaIdSuffix}`}
          variant="link"
          className="add-remove-button__button"
          onClick={onRemoveClick}
        >
          {showDiamond ? (
            <DiamondIcon className="diamond-icon" />
          ) : (
            <TrashIcon className="trash-icon" color={link} ratio={0.5} />
          )}
          {removeLabel}
        </Button>
      )}
    </div>
  </div>
);
